import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import LgpdPage from '@/pages/lgpd/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/lgpd',
    element: <LgpdPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
